<div class="label-field">
  <div [innerHTML]="field().label"></div>
  <div class="label-hint" [innerHTML]="field().hintText"></div>
</div>
